/*
 * Copyright (c) 2022, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React, { useEffect } from "react";

import { Box, FormControl, TextField } from "@material-ui/core";
import { useStyles } from "./styles";
import { Autocomplete } from "@material-ui/lab";

interface CustomAutoCompleteProps {
  placeholder?: string;
  disabled?: boolean;
  textFieldStyle?: string;
  tagStyle?: string;
  options: string[];
  defaultValues?: string[];
  label?: string;
  onChange: (event: unknown, value: any) => void;
  errorText?: string;
  containerStyle?: string;
}

const CustomAutoComplete = (props: CustomAutoCompleteProps) => {
  const { 
    placeholder, 
    disabled, 
    textFieldStyle, 
    tagStyle, 
    options, 
    defaultValues, 
    label, 
    onChange,
    errorText = '',
    containerStyle
  } = props;
  const classes = useStyles();

  return (
    <Box className={containerStyle}>
      <Autocomplete
        className={classes.autoComplete && tagStyle}
        multiple
        options={options}
        disabled={disabled}
        fullWidth
        filterSelectedOptions
        onChange={onChange}
        defaultValue={defaultValues}
        freeSolo
        renderInput={(params) => (
          <TextField
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...params}
            helperText={errorText}
            error={errorText !== ''}
            placeholder={placeholder}
            fullWidth
            label={label}
            type="text"
            variant="outlined"
            className={textFieldStyle}
            rows={1}
            data-testid="autocomplete-textfield"
          />
        )}
      />
    </Box>
  );
};
export default CustomAutoComplete;
